import { ValueOf } from '@/types/util';

export const campaignStatus = {
  NEW: '新規',
  WAITING: '開催待ち',
  IN_PROGRESS: '開催中',
  FINISH: '終了',
  CANCEL: '取消',
} as const;

export type CampaignStatusKey = keyof typeof campaignStatus;
export type CampaignStatusValue = ValueOf<typeof campaignStatus>;

export const campaignStatusKeys = Object.keys(campaignStatus) as CampaignStatusKey[];

/** v-select用items */
export const campaignStatusItems = campaignStatusKeys
  .map((key) => ({
    title: campaignStatus[key],
    value: key,
  }));
